// extracted by mini-css-extract-plugin
export default {"pageBG":"TradingSpacePage_pageBG__2b6lX"};